import { render, staticRenderFns } from "./MMP_Extents.vue?vue&type=template&id=315d34c2&"
import script from "./MMP_Extents.vue?vue&type=script&lang=js&"
export * from "./MMP_Extents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports